module.exports = __webpack_public_path__ + "static/media/hogar-ico.238a2c67.svg";